import type { User } from "@/features/auth/store/authStore"
import i18n from "@/language"

export function isProfileFullyCompleted(user: User): boolean {
  // Check basic info
  const hasBasicInfo = !!(user.name && user.username && user.bio)

  // Check cover image
  const hasCoverImage = user.profile_photos?.some(p => p.isCover || p.is_cover_image) ?? false

  // Check spiritual traditions
  const hasSpiritualTraditions = (user.spiritual_traditions?.length ?? 0) > 0

  // Check ethnic backgrounds
  const hasEthnicBackgrounds = (user.ethnic_backgrounds?.length ?? 0) > 0

  // Check intentions
  const hasIntentions = (user.intentions?.length ?? 0) > 0

  return (
    hasBasicInfo && hasCoverImage && hasSpiritualTraditions && hasEthnicBackgrounds && hasIntentions
  )
}

export function getAllProfileItems(
  user: User,
): Array<{ key: string; label: string; isComplete: boolean }> {
  const items: Array<{ key: string; label: string; isComplete: boolean }> = []

  // Cover photo
  items.push({
    key: "coverPhoto",
    label: i18n.t("profileCompletion.coverImage", { ns: "profile" }),
    isComplete: !!user.profile_photos?.some(p => p.isCover || p.is_cover_image),
  })

  // Bio
  items.push({
    key: "bio",
    label: i18n.t("profileCompletion.basicInfo", { ns: "profile" }),
    isComplete: !!user.bio,
  })

  // Spiritual traditions
  items.push({
    key: "spiritualTraditions",
    label: i18n.t("profileCompletion.spiritualTraditions", { ns: "profile" }),
    isComplete: (user.spiritual_traditions?.length ?? 0) > 0,
  })

  // Ethnic backgrounds
  items.push({
    key: "ethnicBackground",
    label: i18n.t("profileCompletion.ethnicBackgrounds", { ns: "profile" }),
    isComplete: (user.ethnic_backgrounds?.length ?? 0) > 0,
  })

  // Intentions
  items.push({
    key: "intentions",
    label: i18n.t("profileCompletion.intentions", { ns: "profile" }),
    isComplete: (user.intentions?.length ?? 0) > 0,
  })

  return items
}
